export default __webpack_public_path__ + "static/sc-09d0383d66ae637e300914b8977fc418.svg";